import axios from "axios";

export const getRequest = axios.get;
